import { set } from 'lodash-es';

export default {
    updateUserProperties(properties) {
        Object.keys(properties).forEach((path) => {
            set(this.currentForm, path, properties[path]);
        });
    },
};
